import React from 'react';
import { formatPhoneNumber } from '../../utils/format';
import EtudiantActionButtons from './EtudiantActionButtons';

const EtudiantTableRow = ({ 
  etudiant, 
  onEdit, 
  onCreateAccount 
}) => {
  return (
    <tr className="hover:bg-gray-50">
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm font-medium text-gray-900">
          {etudiant.matricule}
        </div>
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-900">
          {etudiant.nom} {etudiant.prenom}
        </div>
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-900">
          {etudiant.get_filiere && etudiant.get_niveau ? 
            `${etudiant.get_filiere} - ${etudiant.get_niveau}` : 
            'Non inscrit'}
        </div>
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-900">
          {formatPhoneNumber(etudiant.contact)}
        </div>
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-900">
          {etudiant.email}
        </div>
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <EtudiantActionButtons
          etudiant={etudiant}
          onEdit={onEdit}
          onCreateAccount={onCreateAccount}
        />
      </td>
    </tr>
  );
};

export default EtudiantTableRow;
